/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiScenarioEntityType {
    PERSON = 'PERSON',
    TRANSACTION = 'TRANSACTION'
}


export function instanceOfApiScenarioEntityType(value: any): boolean {
    for (const key in ApiScenarioEntityType) {
        if (Object.prototype.hasOwnProperty.call(ApiScenarioEntityType, key)) {
            if (ApiScenarioEntityType[key as keyof typeof ApiScenarioEntityType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiScenarioEntityTypeFromJSON(json: any): ApiScenarioEntityType {
    return ApiScenarioEntityTypeFromJSONTyped(json, false);
}

export function ApiScenarioEntityTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiScenarioEntityType {
    return json as ApiScenarioEntityType;
}

export function ApiScenarioEntityTypeToJSON(value?: ApiScenarioEntityType | null): any {
    return value as any;
}

export function ApiScenarioEntityTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiScenarioEntityType {
    return value as ApiScenarioEntityType;
}

